var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgErpConnections = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  className: "erp-connections",
  viewBox: "0 0 95 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint0_linear_3465_36390)",
  d: "M0 10h95"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint6_linear_3465_36390)",
  d: "M0 10h95",
  className: "blue1"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint1_linear_3465_36390)",
  d: "M0 47.5h23.75L47.5 34H95"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint6_linear_3465_36390)",
  d: "M0 47.5h23.75L47.5 34H95",
  className: "blue1"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint5_linear_3465_36390)",
  d: "M0 16h95"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint6_linear_3465_36390)",
  d: "M0 16h95",
  className: "blue1"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint3_linear_3465_36390)",
  d: "M0 28h95"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint6_linear_3465_36390)",
  d: "M0 28h95",
  className: "blue1"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint4_linear_3465_36390)",
  d: "M0 22h95"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint6_linear_3465_36390)",
  d: "M0 22h95",
  className: "blue1"
})), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_3465_36390",
  x1: 88.702,
  x2: 2.099,
  y1: 9.5,
  y2: 9.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C2C2D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0E0EB"
}))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_3465_36390",
  x1: 88.702,
  x2: 2.099,
  y1: 33.5,
  y2: 33.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C2C2D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0E0EB"
}))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_3465_36390",
  x1: 88.702,
  x2: 2.099,
  y1: 27.5,
  y2: 27.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C2C2D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0E0EB"
}))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_3465_36390",
  x1: 88.702,
  x2: 2.099,
  y1: 21.5,
  y2: 21.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C2C2D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0E0EB"
}))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_3465_36390",
  x1: 88.702,
  x2: 2.099,
  y1: 15.5,
  y2: 15.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C2C2D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0E0EB"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_3465_36390",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "0%",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  style: {
    stopColor: "#2f64ed",
    stopOpacity: 0.2
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  style: {
    stopColor: "#2f64ed",
    stopOpacity: 0.5
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  style: {
    stopColor: "#2f64ed",
    stopOpacity: 1
  }
}))));
export { SvgErpConnections as ReactComponent };
export default "data:image/svg+xml;base64,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";